// extracted by mini-css-extract-plugin
module.exports = {"singlePipeline":"SinglePipeline_singlePipeline__16kda","changeButton":"SinglePipeline_changeButton__3i1X6"};